var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9996 1.99902C17.5233 1.99902 22.0011 6.47687 22.0011 12.0006C22.0011 17.5243 17.5233 22.0021 11.9996 22.0021C6.47589 22.0021 1.99805 17.5243 1.99805 12.0006C1.99805 6.47687 6.47589 1.99902 11.9996 1.99902ZM11.9996 3.49902C7.30432 3.49902 3.49805 7.3053 3.49805 12.0006C3.49805 16.6959 7.30432 20.5021 11.9996 20.5021C16.6949 20.5021 20.5011 16.6959 20.5011 12.0006C20.5011 7.3053 16.6949 3.49902 11.9996 3.49902ZM11.996 10.4996C12.3757 10.4994 12.6896 10.7813 12.7395 11.1473L12.7464 11.2491L12.75 16.7507C12.7503 17.1649 12.4147 17.5009 12.0005 17.5012C11.6208 17.5014 11.3069 17.2195 11.257 16.8535L11.25 16.7517L11.2464 11.2501C11.2462 10.8359 11.5817 10.4999 11.996 10.4996ZM12 7.00184C12.5516 7.00184 12.9987 7.44896 12.9987 8.0005C12.9987 8.55205 12.5516 8.99917 12 8.99917C11.4485 8.99917 11.0014 8.55205 11.0014 8.0005C11.0014 7.44896 11.4485 7.00184 12 7.00184Z",
    fill: "#FF4747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.54b6f1b445581c5de4883a98b74f3aec.svg";
export { ForwardRef as ReactComponent };